import React, { ChangeEvent, SyntheticEvent } from 'react';

import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';

import Typography from '@material-ui/core/Typography';
import classNames from 'classnames'

import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import DashboardIcon from '@material-ui/icons/Dashboard';
import BranchScheduleIcon from '@material-ui/icons/DeviceHub'
import ResourceIcon from '@material-ui/icons/FormatPaint';
import BlockIcon from '@material-ui/icons/Block';
import ImportExportIcon from '@material-ui/icons/SwapVert';
import TasksIcon from '@material-ui/icons/DoneAll';
import ScheduleIcon from '@material-ui/icons/Today';
import AssessmentIcon from '@material-ui/icons/Assessment';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import PeopleIcon from '@material-ui/icons/People';
import PhasePlanIcon from '@material-ui/icons/ClearAll';
import ClosedMenuIcon from '@material-ui/icons/ArrowLeft'
import OpenMenuIcon from '@material-ui/icons/ArrowDropDown'
import WidgetsIcon from '@material-ui/icons/Widgets'
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import { Link } from 'react-router-dom';

import { homeStyles } from '../containers/dockPadStyle'

import { compose } from 'redux';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { ThunkDispatch } from 'redux-thunk';
import { connect } from 'react-redux';
import { uiActions } from '../actions/ui.actions';
import List from '@material-ui/core/List';
import Collapse from '@material-ui/core/Collapse';
import { hasStartedPhasePlan } from '../selectors/phaseplan.selector';
import {withGetScreen} from 'react-getscreen'
import AddIcon from '@material-ui/icons/Add';

import packageJson from '../../package.json';
import IconButton from '@material-ui/core/IconButton';
import ErrorIcon from '@material-ui/icons/Error';
import { hasLookaheadPlans } from '../selectors/lookahead.selector';
import { dialogActions } from '../actions/dialog.actions';
import AreaIcon from '@material-ui/icons/ZoomOutMap'

export interface Props {
    classes: ClassNameMap,
    location: any,
    toggleExpandedPhasePlanMenu: () => Promise<void>,
    isPhasePlanMenuExpanded: boolean,
    hasLookaheadPlans: boolean,
    isMobile: () => boolean;
    isTablet: () => boolean;
    openMRPDialog: () => void
}

const _LeftNav: React.FunctionComponent<Props> = ({ classes, location, toggleExpandedPhasePlanMenu, isPhasePlanMenuExpanded, hasLookaheadPlans, isMobile, isTablet, openMRPDialog }) => {
    const renderLinkTo = (icon: JSX.Element, text:string, linkTo: string) => {
        const pathName = location.pathname;
        return (
            <ListItem
                dense={true}
                className={classNames(classes.navListItems)}
                selected={pathName == linkTo}
                component={Link}
                to={linkTo}
                button
            >
                <ListItemIcon>{icon}</ListItemIcon>
                <ListItemText
                    primary={<p className={classNames(classes.navText)}>{text}</p>}
                />
            </ListItem>
        );
    }

    const renderSubLinkTo = (icon: JSX.Element, text:string, linkTo: string) => {
        const pathName = location.pathname;
        return (
            <ListItem
                dense={true}
                className={classNames(classes.navListItems, classes.nested)}
                selected={pathName == linkTo}
                component={Link}
                to={linkTo}
                button
            >
                <ListItemIcon>{icon}</ListItemIcon>
                <ListItemText
                    inset
                    primary={<p className={classNames(classes.navText)}>{text}</p>}
                />
            </ListItem>
        );
    }

    const shouldRenderPhasePlan = () => {

        
        return (
            <Collapse in={isPhasePlanMenuExpanded} timeout="auto" unmountOnExit >
                <List component="div" disablePadding>
                    {renderSubLinkTo(
                        <EventAvailableIcon className={classNames(classes.navTextIcons)} />,
                        'Make Ready Plan',
                        '/lookahead'
                    )}
                </List>
            </Collapse>
        )
    }

  

    const renderMakeReadyPlan = () => {
        
        if(!hasLookaheadPlans) {
            return
        }
        
        return (
            renderLinkTo(
                <EventAvailableIcon className={classNames(classes.navTextIcons)} />,
                'Make Ready Plan',
                '/lookahead'
            )
        )
    }

    const renderCreatePlanButton = () => {
        if(hasLookaheadPlans) {
            return
        }

        return (
            <ListItem
                dense={true}
                className={classNames(classes.navListItems)}
                onClick={openMRPDialog}
                button
            >
                <ListItemIcon><ErrorIcon className={classNames(classes.navTextIcons)} /></ListItemIcon>
                <ListItemText
                    primary={<p className={classNames(classes.navText)}>Create Your First Plan</p>}
                />
            </ListItem>
        )
    
    }
    
    return(
        <React.Fragment>
            <div className={classNames(classes.homeListDivider)}>
               

                {renderLinkTo(
                    <DashboardIcon className={classNames(classes.navTextIcons)} />,
                    'Huddle',
                    '/'
                )}
                {/*renderLinkTo(
                    <AssessmentIcon className={classNames(classes.navTextIcons)} />,
                    'Commitment Reports',
                    '/ppc_report'
                )*/}
                {
                    /*
                        renderLinkTo(
                        <AreaIcon className={classNames(classes.navTextIcons)} />,
                        'Area',
                        '/areas'
                    )*/
                }
            </div>
            {/*
            <div className={classNames(classes.homeListDivider)}>
                <div className={classNames(classes.LeftNavButtonRow)}>
                    <Typography
                        className={classNames(classes.navTextHeaders)}
                        variant="subheading"
                        align="left"
                        gutterBottom
                    >
                        Plans
                    </Typography>
                    <IconButton onClick={openMRPDialog} className={classes.navTextIcons} style={{padding: '0px' }}>
                        <AddIcon />
                    </IconButton>
                </div>
                {renderCreatePlanButton()}

                {renderMakeReadyPlan()}
                
            </div>
            */}



            
            <div className={classNames(classes.homeListDivider)}>
                <Typography
                    className={classNames(classes.navTextHeaders)}
                    variant="subheading"
                    align="left"
                    gutterBottom
                >
                    People
          </Typography>
            </div>
            {renderLinkTo(
                <PeopleIcon className={classNames(classes.navTextIcons)} />,
                'Team',
                '/team'
            )}
            {renderLinkTo(
                <AccountCircleIcon className={classNames(classes.navTextIcons)} />,
                'Profile',
                '/profile'
            )}
        </React.Fragment>
    
    )
}

const mapStateToProps = (state: any) => {
    return {
        hasLookaheadPlans: hasLookaheadPlans(state)
    }
};

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

    return {
        toggleExpandedPhasePlanMenu: () => dispatch(uiActions.expandPhasePlanMenuAction()),
        openMRPDialog: () => dispatch(dialogActions.openMRPDialog())
    }
};

export default compose(
    
    withRouter,
    withStyles(homeStyles, { withTheme: true }),
    withGetScreen,

    connect(mapStateToProps, mapDispatchToProps)
)(_LeftNav)


// WEBPACK FOOTER //
// ./src/components/LeftNav.tsx